import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { AppState } from '@core/store';
import { resetPartyAndIsOrderCreditToHostParty } from '@core/store/consultant/consultant.actions';
import { RouterQueryParams } from '@core/enums/router-query-param.enum';
import { AppInitService } from '@core/services/app-init.service';
import { LocalStorageService } from '@core/services/local-storage.service';
import { BaseComponent } from '@shared/components/base-component/base-component';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-party-initializer',
  template: '',
})
export class PartyInitializerComponent extends BaseComponent implements OnInit, OnDestroy {
  constructor(
    private router: Router,
    private localStorageService: LocalStorageService,
    private appInitService: AppInitService,
    private store$: Store<AppState>,
  ) {
    super();
  }

  ngOnInit(): void {
    if (!this.appInitService.Settings.ec.isPartyEnabled) {
      this.localStorageService.removeItem(RouterQueryParams.partyId);
      this.store$.dispatch(resetPartyAndIsOrderCreditToHostParty());
      return;
    }

    this.subscriptions.add(
      this.router.events
        .pipe(filter((e) => e instanceof NavigationStart))
        .subscribe((e: NavigationStart) => {
          const partyId = this.router.parseUrl(e.url).queryParams?.[RouterQueryParams.partyId];

          if (partyId) {
            this.localStorageService.setItem(RouterQueryParams.partyId, partyId);
          }
        }),
    );
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
